import React, { memo } from 'react';
import cls from './StageItem.module.css';
import classNames from 'classnames';
import { ItemResizer } from '../ItemResizer/ItemResizer';
import { ItemMover } from '../ItemMover/ItemMover';
import { useResizeStage } from '../../../hooks/useResizeStage';
import { useMoveStage } from '../../../hooks/useMoveStage';
import { PlanFactStageItem } from './PlanFactStageItem';
import { getFinalWidth } from '../../../helpers/getFinalWidth';
import { SmallMainElement } from '../SmallMainElement/SmallMainElement';
import { useSelector } from 'react-redux';

export const StageItem = memo(({ stage, isPlanFact }) => {
    const { activeTab } = useSelector((state) => state.gantReducer);

    const { positionX, handleMouseMove, handleMouseUp } = useMoveStage(stage, activeTab);

    const { elWidth, changeWidth, onItemChange } = useResizeStage(stage, activeTab);

    if (!stage) {
        return null;
    }

    let finalWidth = getFinalWidth(elWidth, activeTab, stage.planned.days_count);

    let isShowSmallMain = true;

    if (activeTab !== 'day') {
        if (activeTab === 'week' && elWidth < 11) {
            isShowSmallMain = false;
        }
        if (activeTab === 'month' && elWidth < 14) {
            isShowSmallMain = false;
        }
    }

    const isSmall = elWidth < 97;

    return (
        <>
            {isPlanFact ? (
                <PlanFactStageItem stage={stage} />
            ) : (
                <>
                    <div className={classNames(cls.wrapper)}>
                        <div
                            id={`${stage.id}`}
                            style={{ left: positionX }}
                            className={classNames(cls.StageItem, { [cls.planFact]: isPlanFact })}
                        >
                            {isShowSmallMain && (
                                <svg
                                    width="12"
                                    height="32"
                                    viewBox="0 0 12 32"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                >
                                    <path
                                        d="M0 4.57143C0 2.0467 1.79086 0 4 0H8C10.2091 0 12 2.0467 12 4.57143V27.4286C12 29.9533 10.2091 32 8 32H4C1.79086 32 0 29.9533 0 27.4286V4.57143Z"
                                        fill="#E6E6E6"
                                    />
                                    <path
                                        d="M12 6H8V5C8 4.44772 7.55228 4 7 4H5C4.44772 4 4 4.44772 4 5V27C4 27.5523 4.44772 28 5 28H7C7.55228 28 8 27.5523 8 27V26H12V28C12 30.2091 10.2091 32 8 32H4C1.79086 32 0 30.2091 0 28V4C0 1.79086 1.79086 0 4 0H8C10.2091 0 12 1.79086 12 4V6Z"
                                        fill="#1094F7"
                                    />
                                </svg>
                            )}

                            <ItemMover onMove={handleMouseMove} onMouseUp={handleMouseUp}>
                                {/*<ReactTooltip*/}
                                {/*    id={`diagram-stage-${stage.id}`}*/}
                                {/*    aria-haspopup="true"*/}
                                {/*    effect="solid"*/}
                                {/*    delayHide={200}*/}
                                {/*    delayShow={200}*/}
                                {/*    type="light"*/}
                                {/*    className={cls.tooltip}*/}
                                {/*>*/}
                                {/*    <p>{stage.name}</p>*/}
                                {/*</ReactTooltip>*/}
                                {!isShowSmallMain ? (
                                    <div>
                                        <SmallMainElement
                                            daysCount={stage.planned.days_count}
                                            width={finalWidth}
                                            variant={'stage'}
                                            elWidth={elWidth}
                                            onResize={changeWidth}
                                            onStageChange={onItemChange}
                                            classes={cls.resizer}
                                        />
                                    </div>
                                ) : (
                                    <div
                                        title={stage.name}
                                        data-tip
                                        data-for={`diagram-stage-${stage.id}`}
                                        style={{ width: finalWidth }}
                                        className={classNames(cls.MainElement, {
                                            [cls.backgroundFact]: isPlanFact,
                                            [cls.small]: isSmall,
                                            [cls.notRightPadding]:
                                                (+stage.planned.days_count < 3 &&
                                                    activeTab !== 'day') ||
                                                (elWidth < 22 && activeTab !== 'day'),
                                        })}
                                    >
                                        <span className={cls.text}>{stage?.name}</span>
                                    </div>
                                )}
                            </ItemMover>

                            <div className={classNames(cls.resizerStage)}>
                                {isShowSmallMain && (
                                    <>
                                        <ItemResizer
                                            onResize={changeWidth}
                                            elWidth={elWidth}
                                            onStageChange={onItemChange}
                                            classes={cls.resizer}
                                        />
                                        <svg
                                            style={{
                                                marginLeft: `${
                                                    stage.planned.days_count === '2' &&
                                                    activeTab !== 'day'
                                                        ? '-2px'
                                                        : '-1px'
                                                }`,
                                                cursor: 'ew-resize',
                                            }}
                                            width="12"
                                            height="32"
                                            viewBox="0 0 12 32"
                                            fill="none"
                                            xmlns="http://www.w3.org/2000/svg"
                                        >
                                            <path
                                                d="M12 4.57143C12 2.0467 10.2091 0 8 0H4C1.7909 0 0 2.0467 0 4.57143V27.4286C0 29.9533 1.7909 32 4 32H8C10.2091 32 12 29.9533 12 27.4286V4.57143Z"
                                                fill="#E6E6E6"
                                            />
                                            <path
                                                d="M0 6H4V5C4 4.44772 4.44772 4 5 4H7C7.55228 4 8 4.44772 8 5V27C8 27.5523 7.55228 28 7 28H5C4.44772 28 4 27.5523 4 27V26H0V28C0 30.2091 1.79086 32 4 32H6H8C10.2091 32 12 30.2091 12 28V4C12 1.79086 10.2091 0 8 0H4C1.79086 0 0 1.79086 0 4V6Z"
                                                fill="#1094F7"
                                            />
                                        </svg>
                                    </>
                                )}
                            </div>
                        </div>
                    </div>
                </>
            )}
        </>
    );
});
